import axios, { AxiosError, AxiosInstance } from "axios";
import { env } from "@/config/env";
import type { ApiError } from "@/types";

/**
 * Shared, typed HTTP client.
 *
 * Every network call goes through this instance so base URL, headers,
 * timeouts and error normalization are configured once. Future concerns
 * (auth tokens, retry, tracing) attach here as interceptors — no component
 * changes needed.
 */
export const apiClient: AxiosInstance = axios.create({
  baseURL: env.apiBaseUrl,
  timeout: 20000,
  headers: { "Content-Type": "application/json" },
});

/** Normalizes any thrown error into a readable message. */
export function toApiErrorMessage(error: unknown): string {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<ApiError>;
    const detail = axiosError.response?.data?.detail;
    if (detail) return detail;
    if (axiosError.code === "ECONNABORTED") return "The request timed out.";
    return axiosError.message;
  }
  if (error instanceof Error) return error.message;
  return "Something went wrong. Please try again.";
}
